var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 65,
    height: 65,
    rx: 28,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 65,
    height: 65,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3327 35.2733V36.5C50.331 39.3752 49.4 42.1729 47.6785 44.4758C45.9569 46.7786 43.5371 48.4633 40.7798 49.2785C38.0226 50.0938 35.0757 49.9959 32.3786 48.9994C29.6816 48.003 27.3789 46.1615 25.814 43.7494C24.249 41.3374 23.5057 38.4841 23.6949 35.6151C23.8841 32.7461 24.9956 30.0151 26.8637 27.8294C28.7318 25.6438 31.2564 24.1205 34.0609 23.4869C36.8655 22.8532 39.7997 23.1431 42.426 24.3133M50.3327 25.8333L36.9994 39.18L32.9994 35.18",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedLarge);
export default __webpack_public_path__ + "static/media/CheckedLarge.5a27fb591213a60e5db036dd46ce9b56.svg";
export { ForwardRef as ReactComponent };